import { FormHeaderCheckbox } from 'components/shared/FormHeaderCheckbox/FormHeaderCheckbox';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import { OrdersBasketHeaderCell } from './HeaderCell/OrdersBasketHeaderCell';
import { connectOrdersBasketHeaderComponent } from './OrdersBasketHeader.connect';
import type { OrdersBasketHeaderProps } from './OrdersBasketHeader.models';

export const OrdersBasketHeaderComponent: FC<OrdersBasketHeaderProps> = ({
  productSubType,
  productType,
  productDefinition,
  areAllFormsSelected,
  isNoFormSelected,
  isCheckboxDisabled,
  onCheckboxToggled,
}) => {
  return productDefinition ? (
    <thead>
      <tr>
        <th className="p-0">
          <div className="flex-center-x flex-center-y">
            <FormHeaderCheckbox
              id="orders-basket-select-all"
              e2e="orders-basket-select-all"
              isNoFormSelected={isNoFormSelected}
              areAllFormsSelected={areAllFormsSelected}
              isDisabled={isCheckboxDisabled}
              onToggle={onCheckboxToggled}
            />
          </div>
        </th>
        <th className="text-center">
          <FormattedMessage id="ordersBasket.Status" />
        </th>
        {productDefinition.children?.map(col => (
          <OrdersBasketHeaderCell
            productSubType={productSubType}
            productType={productType}
            key={col.id}
            fieldId={col.id}
            translationKey={col.translationKey}
          />
        ))}
      </tr>
    </thead>
  ) : null;
};

export const OrdersBasketHeader = connectOrdersBasketHeaderComponent(OrdersBasketHeaderComponent);
